import { render, staticRenderFns } from "./institucionesDirector.vue?vue&type=template&id=ba2f0506"
import script from "./institucionesDirector.vue?vue&type=script&lang=js"
export * from "./institucionesDirector.vue?vue&type=script&lang=js"
import style0 from "./institucionesDirector.vue?vue&type=style&index=0&id=ba2f0506&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports